
    <div class="content">
        <app-header></app-header>
        <router-outlet></router-outlet>
    </div>
    
    <div class="footer">
        <app-footer></app-footer>
    </div>
    
